

const initialState = {
    "OriginStationCode": null,
    "DestinationStationCode": null,
    "DepartureDate": null,
    "PassengerCount": 1
};

export default function busSearch(state = initialState, action = {}) {
    switch (action.type) {
        case 'SET_BUS_SEARCH':
            const { search } = action;
            return search;
        // case SET_DATE:
        //     const { date } = action;
        //     return {
        //         ...state,
        //         "OriginDestinationInformation": {
        //             ...state.OriginDestinationInformation,
        //             "DepartureDate": date
        //         }
        //     };
        // case SET_TRAVELER:
        //     const { traveler } = action;
        //     return {
        //         ...state,
        //         "TravelerInfoSummary": {
        //             "AirTravelerAvail": traveler
        //         }
        //     };
        // case CLEAR_SEARCH:
        //     return initialState;
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/redux/reducers/BusSearchReducer.js